import React from 'react';

import classnames from 'classnames';

import SubdomainInput from 'common/inputs/SubdomainInput';
import TextInput from 'common/inputs/TextInput';
import { P } from 'common/ui/Text';

import { FormErrors } from './CreateOrUpdateCompanyForm';

const NewCompanyForm = ({
  companyName,
  fieldError,
  setCompanyName,
  setCompanySubdomain,
  submitting,
}: {
  companyName: string;
  fieldError: {
    invalidCompanyName: boolean;
    invalidSubdomainName: boolean;
  };
  setCompanyName: (value: string) => void;
  setCompanySubdomain: (value: string) => void;
  submitting: boolean;
}) => {
  return (
    <section className="newCompanyContainer">
      <div className="formTextInput">
        <label htmlFor="companyName">Company</label>
        <TextInput
          id="companyName"
          className={classnames('newCompanyField', {
            fieldError: fieldError.invalidCompanyName,
          })}
          aria-label="company name"
          disabled={submitting}
          value={companyName}
          placeholder="e.g. Acme Corp"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setCompanyName(e.currentTarget.value)
          }
          aria-invalid={fieldError.invalidCompanyName}
          aria-errormessage={fieldError.invalidCompanyName ? FormErrors.invalidCompanyName : ''}
        />
        {fieldError.invalidCompanyName ? (
          <P variant="bodySm" className="error">
            {FormErrors.invalidCompanyName}
          </P>
        ) : null}
      </div>
      <div className="formTextInput">
        <label htmlFor="companySubdomain">Subdomain</label>
        <SubdomainInput
          id="companySubdomain"
          className={classnames('newCompanyField', {
            fieldError: fieldError.invalidSubdomainName,
          })}
          aria-label="feedback subdomain"
          placeholder="e.g. https://acme-corp"
          disabled={submitting}
          input={companyName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setCompanySubdomain(e.currentTarget.value)
          }
          aria-invalid={fieldError.invalidSubdomainName}
          aria-errormessage={fieldError.invalidSubdomainName ? FormErrors.invalidSubdomainName : ''}
        />
        {fieldError.invalidSubdomainName ? (
          <P variant="bodySm" className="error">
            {FormErrors.invalidSubdomainName}
          </P>
        ) : null}
      </div>
    </section>
  );
};

export default NewCompanyForm;
